import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Filter as RaFilter } from 'react-admin';
import AppliedFilters from './AppliedFilters';
import MoreFiltersButton, { extractNonAlwaysOnSources } from './MoreFiltersButton';

export const Filter = ({ children, ...props }) => {
    const hasNonAlwaysOn = useMemo(() => {
        const sources = extractNonAlwaysOnSources(children);
        return sources.length > 0;
    }, [children]);

    return (
        <RaFilter {...props}>
            {children}
            {hasNonAlwaysOn ? (
                <MoreFiltersButton alwaysOn filterInputs={children} />
            ) : null}
            <AppliedFilters alwaysOn filterInputs={children} />
        </RaFilter>
    );
};

Filter.propTypes = {
    children: PropTypes.node,
};

Filter.defaultProps = {
    children: null,
};

export { AppliedFilters, MoreFiltersButton };
export default Filter;
